import { gql } from "@apollo/client"

export const GET_STORES = gql`
  query GetStores($filter: StoreFilter, $orderBy: StoreOrderBy, $page: Int, $paginate: Int) {
    stores(filter: $filter, orderBy: $orderBy, page: $page, paginate: $paginate) {
      id
      name
      description
      phone
      email
      website
      logo
      banner
      addressId
      ownerId
      active
      verified
      created
      modified
      Address {
        id
        name
        address
        lattitude
        longitude
        Country {
          id
          name
          iso
        }
        Region {
          id
          name
          alias
          fullName
        }
        Location {
          id
          name
        }
      }
    }
  }
`

export const GET_STORE_BY_ID = gql`
  query GetStoreById($id: Int!) {
    store(id: $id) {
      id
      name
      description
      phone
      email
      website
      logo
      banner
      addressId
      ownerId
      active
      verified
      created
      modified
      Address {
        id
        name
        address
        lattitude
        longitude
        Country {
          id
          name
          iso
        }
        Region {
          id
          name
          alias
          fullName
        }
        Location {
          id
          name
        }
      }
      Tournaments(filter: { statusId: 1 }, orderBy: startDate_DESC, paginate: 10) {
        id
        name
        uid
        description
        image
        startDate
        endDate
        maxPlayers
        rounds
        Game {
          id
          name
          image
          urlImage
        }
        Format {
          id
          name
          description
        }
        Season {
          id
          name
          startDate
          endDate
        }
      }
    }
  }
`

export const GET_STORES_NEAR_LOCATION = gql`
  query GetStoresNearLocation(
    $latitude: Float!
    $longitude: Float!
    $radius: Float = 50
    $page: Int
    $paginate: Int
  ) {
    storesNearLocation(
      latitude: $latitude
      longitude: $longitude
      radius: $radius
      page: $page
      paginate: $paginate
    ) {
      id
      name
      description
      phone
      email
      website
      logo
      banner
      active
      verified
      distance
      Address {
        id
        name
        address
        lattitude
        longitude
        Country {
          id
          name
          iso
        }
        Region {
          id
          name
          alias
        }
        Location {
          id
          name
        }
      }
    }
  }
`
